/*
  Lepljiva mini traka ponude na landing stranicama za reklame.

  Ne računa ništa sama: preslikava poruku i popunjenost iz kutije ponude
  (<bundle-offer>) koja se već osvežava kroz Section Rendering API na
  svaku promenu korpe. Tako su kutija i traka uvek isti podatak.

  Traka se pojavljuje tek kad kutija ode sa ekrana, da ne duplira poruku.
*/
(function () {
  'use strict';

  function init() {
    var box = document.querySelector('bundle-offer.bundle-offer--collection');
    if (!box || document.querySelector('.ads-sticky')) return;

    var bar = document.createElement('div');
    bar.className = 'ads-sticky';
    bar.setAttribute('hidden', '');
    bar.innerHTML =
      '<div class="ads-sticky__inner">' +
      '<p class="ads-sticky__msg"></p>' +
      '<div class="ads-sticky__bar" aria-hidden="true"><span class="ads-sticky__fill"></span></div>' +
      '</div>' +
      '<a class="ads-sticky__cta button" href="/cart"></a>';
    // Prevod iz data atributa na <body> (layout/theme.liquid); fallback postojeci srpski literal
    bar.querySelector('.ads-sticky__cta').textContent = document.body.dataset.adsViewCart || 'Vidi korpu';
    document.body.appendChild(bar);

    var msgEl = bar.querySelector('.ads-sticky__msg');
    var fillEl = bar.querySelector('.ads-sticky__fill');

    function sync() {
      var srcMsg = box.querySelector('.bundle-offer__msg');
      var srcFill = box.querySelector('.bundle-offer__bar-fill');
      if (srcMsg) msgEl.innerHTML = srcMsg.innerHTML;
      if (srcFill) fillEl.style.width = srcFill.style.width || '0%';
      var reached = !!box.querySelector('.bundle-offer__chip.is-reached');
      bar.classList.toggle('is-reached', reached);
    }

    sync();

    // kutija se posle promene korpe cela zameni, pa pratimo njen sadrzaj
    new MutationObserver(sync).observe(box, { childList: true, subtree: true });

    // traka izlazi tek kad kutija nije na ekranu
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.setAttribute('hidden', '');
            } else if (entry.boundingClientRect.top < 0) {
              bar.removeAttribute('hidden');
            } else {
              bar.setAttribute('hidden', '');
            }
          });
        },
        { threshold: 0 }
      ).observe(box);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
